import React, { type FunctionComponent } from 'react'
import { ScheduleDisplayBox, DisplayRow, DisplayLabel } from './styles'

interface Props {
  cronExpression: string
  cronDescription: string
}

export const CronExpressionDisplay: FunctionComponent<React.PropsWithChildren<Props>> = ({
  cronExpression,
  cronDescription,
}) => (
  <>
    <DisplayRow>
      <DisplayLabel>Cron Expression:</DisplayLabel>
      <ScheduleDisplayBox>{cronExpression}</ScheduleDisplayBox>
    </DisplayRow>
    <DisplayRow>
      <DisplayLabel>Schedule Details:</DisplayLabel>
      <ScheduleDisplayBox>{cronDescription}</ScheduleDisplayBox>
    </DisplayRow>
  </>
)
